module.exports = __webpack_public_path__ + "img/caas1.e2973d14.jpg";